import { IKImage } from "imagekitio-react";

const Image = (props: {
  src: string;
  className: string;
  width: string;
  height: string;
  alt: string;
}) => {
  return (
    <IKImage
      urlEndpoint={process.env.REACT_APP_IK_URL_ENDPOINT}
      path={props.src}
      className={props.className}
      loading="lazy"
      lqip={{ active: true, quality: 20 }}
      alt={props.alt}
      width={props.width}
      height={props.height}
      transformation={[
        {
          width: props.width,
          height: props.height,
        },
      ]}
    />
  );
};

export default Image;
